import DashboardTopBarContentView from './DashboardTopBarContentView';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useChatState } from '@core/chat';
import { checkIsAdminRole } from '@helpers/role';

import { IDashboardTopBarContent } from './interfaces';
import { useConference } from '../../DashboardContent/Dolby';

const DashboardTopBarContent = ({
  onOpenInviteUserModal,
}: IDashboardTopBarContent) => {
  const { participants, currentRoom, currentEvent, currentParticipant } =
    useMytaverseEvent();
  const { screenMediaStreams } = useConference();
  const { open: isOpenChat } = useChatState();

  const showInviteUserBtn =
    currentParticipant && currentParticipant.eventRole
      ? checkIsAdminRole(currentParticipant.eventRole)
      : false;
  const participantTotal = participants.filter(({ roomId }) => roomId).length;
  const hasMediaStream = !!screenMediaStreams?.length;

  return (
    <DashboardTopBarContentView
      currentRoom={currentRoom}
      isOpenChat={isOpenChat}
      hasMediaStream={hasMediaStream}
      showInviteUserBtn={showInviteUserBtn}
      participantTotal={participantTotal}
      onOpenInviteUserModal={onOpenInviteUserModal}
      currentEvent={currentEvent}
    />
  );
};

export default DashboardTopBarContent;
